export function pruneArray<Value>(
  array: Array<"" | 0 | false | Value | null | undefined>
): Value[] {
  return array.filter(Boolean) as Value[];
}
